// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginComponent {
  width: 100%;
  display: flex;
  gap: 0px;
  min-height: 100vh;
  background: linear-gradient(180deg, #0b0b6f 0%, #06063f 45%, #020214 75%, #000000 100%);
  color: #fff;
}

.loginLeft {
  padding-left: 100px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.logoContainer img {
  width: 150px;
  margin-bottom: 20px;
}

.logoContainer h1 {
  font-size: 50px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 5px;
  color: #ffffff;
}

.logoContainer p {
  font-size: 16px;
  color: #ffffff;
  margin: 0;
}

.loginRight {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.loginFormContainer {
  background-color: #ffffff;
  color: #333;
  width: 100%;
  max-width: 500px;
  padding: 80px 80px;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
}

.centeredFormHeader {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
}

.formHeader {
  margin-bottom: 10px;
}

.centeredFormHeader h2 {
  color: #2f3299;
  font-weight: 700;
  font-size: 30px;
  margin-bottom: 5px;
}
.formHeader h2 {
  color: #2f3299;
  font-weight: 700;
  font-size: 30px;
  margin-bottom: 5px;
}

.formHeader p {
  color: #555;
  font-size: 14px;
}

.formHeader strong {
  font-weight: 700;
  color: #333;
}

.formHeader span {
  color: #767589;
  padding: 0px 100px 0px 0px;
}

.formLinks {
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: #2f3299;
  font-weight: 700;
  margin-top: -5px;
}

.formLinks p {
  cursor: pointer;
  margin: 0;
}

.loginFormContainer .loginInput {
  background-color: transparent;
  border: 1px solid #888;
}

.loginFormContainer .loginInput input {
  background-color: transparent;
  color: #333;
}

.loginFormContainer .loginInput input::placeholder {
  color: #666;
}

.loginFormContainer .loginInput svg {
  fill: #555;
}

.captchaContainer {
  display: flex;
  flex-direction: column;
}

.store-buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 30px;
}

.store-btn.badge-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #000;
  color: #fff;
  border: 1px solid #777;
  border-radius: 8px;
  padding: 6px 12px;
  min-width: 150px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  width: auto;
}

.store-btn.badge-btn:hover {
  opacity: 0.8;
  background-color: #000;
  box-shadow: none;
}

.badge-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.badge-small {
  font-size: 10px;
  line-height: 12px;
  color: #fff;
}

.badge-large {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  color: #fff;
  letter-spacing: 0.5px;
}

.captchaWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  -webkit-user-select: none;
          user-select: none;
}

.captchaBox {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #4a4c9c;
  border-radius: 8px;
  height: 48px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #000;
  background-color: #fff;
}

.captchaReload {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.captchaReload svg {
  fill: #2f3299;
  width: 32px;
  height: 32px;
}

.captchaReload:hover {
  transform: rotate(90deg);
}

.captchaInputContainer {
  flex: 1 1;
}

.captchaInputContainer input {
  width: 100%;
  height: 48px;
  border: 1px solid #4a4c9c;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 14px;
  background-color: #fff;
  outline: none;
  color: #333;
}

.captchaInputContainer input::placeholder {
  color: #888;
}

.captchaErrorWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}

.captchaError {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ff0000;
  font-size: 12px;
  width: calc(50% - 24px);
}

.errorIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background-color: #ffe6e6;
  border-radius: 50%;
  color: #ff0000;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
}

.otpInputWrapper > div {
  gap: 15px;
}

.otpInputWrapper input {
  width: 60px !important;
  height: 60px !important;
  border-radius: 12px;
  border: 1px solid #4a4c9c;
  background-color: #fff;
  font-size: 24px;
  font-weight: 700;
  color: #333;
  text-align: center;
  outline: none;
  transition: all 0.2s ease;
}

.otpInputWrapper input:focus {
  border: 2px solid #2f3299;
}

/* Tablet Media Query */
@media (max-width: 1024px) {
  .loginLeft {
    padding-left: 50px;
  }
  .logoContainer h1 {
    font-size: 40px;
  }
  .loginRight {
    padding: 30px;
  }
  .loginFormContainer {
    padding: 60px 40px;
  }
}

/* Mobile Media Query */
@media (max-width: 768px) {
  .loginComponent {
    flex-direction: column;
  }
  .loginLeft {
    padding: 40px 20px;
    flex: none;
  }
  .loginRight {
    flex: 1 1;
    padding: 20px;
    align-items: flex-start;
  }
  .logoContainer img {
    width: 100px;
    margin-bottom: 10px;
  }
  .logoContainer h1 {
    font-size: 32px;
  }
  .loginFormContainer {
    width: 100%;
    padding: 40px 25px;
    margin: 0 auto;
  }
  .formHeader h2 {
    font-size: 26px;
  }
  .formHeader span {
    padding: 0;
  }
  .otpInputWrapper > div {
    gap: 10px;
  }
  .otpInputWrapper input {
    width: 50px !important;
    height: 50px !important;
    font-size: 20px;
  }
  .captchaWrapper {
    gap: 8px;
  }
  .captchaBox {
    font-size: 16px;
    height: 42px;
  }
  .captchaInputContainer input {
    height: 42px;
    padding: 0 10px;
  }
  .captchaReload svg {
    width: 26px;
    height: 26px;
  }
  .captchaError {
    width: calc(50% - 15px);
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .logoContainer h1 {
    font-size: 24px;
  }
  .otpInputWrapper > div {
    gap: 6px;
  }
  .otpInputWrapper input {
    width: 42px !important;
    height: 42px !important;
    font-size: 18px;
    border-radius: 8px;
  }
  .formHeader h2 {
    font-size: 24px;
  }
  .captchaError {
    width: 100%;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/login/loginComponent.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,uFAAuF;EACvF,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,SAAO;IACP,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".loginComponent {\n  width: 100%;\n  display: flex;\n  gap: 0px;\n  min-height: 100vh;\n  background: linear-gradient(180deg, #0b0b6f 0%, #06063f 45%, #020214 75%, #000000 100%);\n  color: #fff;\n}\n\n.loginLeft {\n  padding-left: 100px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.logoContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.logoContainer img {\n  width: 150px;\n  margin-bottom: 20px;\n}\n\n.logoContainer h1 {\n  font-size: 50px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-bottom: 5px;\n  color: #ffffff;\n}\n\n.logoContainer p {\n  font-size: 16px;\n  color: #ffffff;\n  margin: 0;\n}\n\n.loginRight {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.loginFormContainer {\n  background-color: #ffffff;\n  color: #333;\n  width: 100%;\n  max-width: 500px;\n  padding: 80px 80px;\n  border-radius: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  /* gap: 20px; */\n}\n\n.centeredFormHeader {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.formHeader {\n  margin-bottom: 10px;\n}\n\n.centeredFormHeader h2 {\n  color: #2f3299;\n  font-weight: 700;\n  font-size: 30px;\n  margin-bottom: 5px;\n}\n.formHeader h2 {\n  color: #2f3299;\n  font-weight: 700;\n  font-size: 30px;\n  margin-bottom: 5px;\n}\n\n.formHeader p {\n  color: #555;\n  font-size: 14px;\n}\n\n.formHeader strong {\n  font-weight: 700;\n  color: #333;\n}\n\n.formHeader span {\n  color: #767589;\n  padding: 0px 100px 0px 0px;\n}\n\n.formLinks {\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: #2f3299;\n  font-weight: 700;\n  margin-top: -5px;\n}\n\n.formLinks p {\n  cursor: pointer;\n  margin: 0;\n}\n\n.loginFormContainer .loginInput {\n  background-color: transparent;\n  border: 1px solid #888;\n}\n\n.loginFormContainer .loginInput input {\n  background-color: transparent;\n  color: #333;\n}\n\n.loginFormContainer .loginInput input::placeholder {\n  color: #666;\n}\n\n.loginFormContainer .loginInput svg {\n  fill: #555;\n}\n\n.captchaContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.store-buttons-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.store-btn.badge-btn {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #000;\n  color: #fff;\n  border: 1px solid #777;\n  border-radius: 8px;\n  padding: 6px 12px;\n  min-width: 150px;\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n  width: auto;\n}\n\n.store-btn.badge-btn:hover {\n  opacity: 0.8;\n  background-color: #000;\n  box-shadow: none;\n}\n\n.badge-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.badge-small {\n  font-size: 10px;\n  line-height: 12px;\n  color: #fff;\n}\n\n.badge-large {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #fff;\n  letter-spacing: 0.5px;\n}\n\n.captchaWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  user-select: none;\n}\n\n.captchaBox {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #4a4c9c;\n  border-radius: 8px;\n  height: 48px;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #000;\n  background-color: #fff;\n}\n\n.captchaReload {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease;\n}\n\n.captchaReload svg {\n  fill: #2f3299;\n  width: 32px;\n  height: 32px;\n}\n\n.captchaReload:hover {\n  transform: rotate(90deg);\n}\n\n.captchaInputContainer {\n  flex: 1;\n}\n\n.captchaInputContainer input {\n  width: 100%;\n  height: 48px;\n  border: 1px solid #4a4c9c;\n  border-radius: 8px;\n  padding: 0 15px;\n  font-size: 14px;\n  background-color: #fff;\n  outline: none;\n  color: #333;\n}\n\n.captchaInputContainer input::placeholder {\n  color: #888;\n}\n\n.captchaErrorWrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 5px;\n}\n\n.captchaError {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ff0000;\n  font-size: 12px;\n  width: calc(50% - 24px);\n}\n\n.errorIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  background-color: #ffe6e6;\n  border-radius: 50%;\n  color: #ff0000;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.otpInputWrapper > div {\n  gap: 15px;\n}\n\n.otpInputWrapper input {\n  width: 60px !important;\n  height: 60px !important;\n  border-radius: 12px;\n  border: 1px solid #4a4c9c;\n  background-color: #fff;\n  font-size: 24px;\n  font-weight: 700;\n  color: #333;\n  text-align: center;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.otpInputWrapper input:focus {\n  border: 2px solid #2f3299;\n}\n\n/* Tablet Media Query */\n@media (max-width: 1024px) {\n  .loginLeft {\n    padding-left: 50px;\n  }\n  .logoContainer h1 {\n    font-size: 40px;\n  }\n  .loginRight {\n    padding: 30px;\n  }\n  .loginFormContainer {\n    padding: 60px 40px;\n  }\n}\n\n/* Mobile Media Query */\n@media (max-width: 768px) {\n  .loginComponent {\n    flex-direction: column;\n  }\n  .loginLeft {\n    padding: 40px 20px;\n    flex: none;\n  }\n  .loginRight {\n    flex: 1;\n    padding: 20px;\n    align-items: flex-start;\n  }\n  .logoContainer img {\n    width: 100px;\n    margin-bottom: 10px;\n  }\n  .logoContainer h1 {\n    font-size: 32px;\n  }\n  .loginFormContainer {\n    width: 100%;\n    padding: 40px 25px;\n    margin: 0 auto;\n  }\n  .formHeader h2 {\n    font-size: 26px;\n  }\n  .formHeader span {\n    padding: 0;\n  }\n  .otpInputWrapper > div {\n    gap: 10px;\n  }\n  .otpInputWrapper input {\n    width: 50px !important;\n    height: 50px !important;\n    font-size: 20px;\n  }\n  .captchaWrapper {\n    gap: 8px;\n  }\n  .captchaBox {\n    font-size: 16px;\n    height: 42px;\n  }\n  .captchaInputContainer input {\n    height: 42px;\n    padding: 0 10px;\n  }\n  .captchaReload svg {\n    width: 26px;\n    height: 26px;\n  }\n  .captchaError {\n    width: calc(50% - 15px);\n  }\n}\n\n/* Small Mobile */\n@media (max-width: 480px) {\n  .logoContainer h1 {\n    font-size: 24px;\n  }\n  .otpInputWrapper > div {\n    gap: 6px;\n  }\n  .otpInputWrapper input {\n    width: 42px !important;\n    height: 42px !important;\n    font-size: 18px;\n    border-radius: 8px;\n  }\n  .formHeader h2 {\n    font-size: 24px;\n  }\n  .captchaError {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
